import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import Content from "../../layout/content/Content";
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Button, Icon, TooltipComponent } from "../../components/Component";
import { useNavigate } from "react-router-dom";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import { useForm } from "react-hook-form";
import { BASE_URL_IMG } from "../../assets/constants";
import { getDoctorListAPI, updateDoctorAPI } from "../../api/doctor";
import useLogout from "../../hooks/useLogout";
import { toast } from "react-toastify";
import { Badge, DropdownMenu, DropdownToggle, UncontrolledDropdown } from "reactstrap";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import FeatureModal from "../../MyComp/UI/modals/FeatureModal";
import { UserAvatarCell } from "../../MyComp/ImagePre/UserAvatarCell";
const DoctorList = () => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      loading: false,
      data: [],
    },
  });
  const isLoading = watch("isLoading");
  const loading = watch("loading");
  const data = watch("data");
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [featureModal, setFeatureModal] = useState(false);
  const [column, setColumn] = useState([
    {
      name: "Doctor",
      selector: (row) => row?.name,
      cell: (row) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
            padding: "6px 0",
          }}
        >
          {/* <img
            src={row?.profileImage ? `${BASE_URL_IMG}${row.profileImage}` : "/default-avatar.png"}
            alt={row?.name || "User"}
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid #e5e7eb",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              cursor: "pointer",
            }}
            onClick={() => handleImageOpenPreview(`${BASE_URL_IMG}` + row?.profileImage)}
          /> */}
             <UserAvatarCell row={row} image={row?.profileImage ? `${BASE_URL_IMG}${row.profileImage}` : "/default-avatar.png"} name={row?.name} handleImageOpenPreview={()=>handleImageOpenPreview(`${BASE_URL_IMG}` + row?.profileImage)} />
          
                                      

          <div style={{ display: "flex", flexDirection: "column" }}>
            <span
              style={{
                fontWeight: 600,
                fontSize: "15px",
                color: "#111827",
                lineHeight: "1.2",
              }}
              className="text-capitalize"
            >
              {"Dr. "}
              {row?.name || "N/A"}
            </span>
            <span
              style={{
                fontSize: "13px",
                color: "#6b7280",
              }}
            >
              {row?.email || "No email"}
            </span>
          </div>
        </div>
      ),
      sortable: true,
      width: "240px",
    },
    {
      name: "Mobile",
      selector: (row) => row?.mobile,
      sortable: true,
      wrap: true,
      width:"120px"
    },
    {
      name: "Degree",
      selector: (row) => row?.degree,
      sortable: true,
      wrap: true,
    },
    {
      name: "Specialization",
      selector: (row) => (
        <>
          <div >
            {row?.speciality?.map((item, index) => (
              <Badge style={{ whiteSpace: "normal", wordBreak: "break-word" }} className="my-1 me-1" color="outline-primary">
                {item?.label}
              </Badge>
            ))}
          </div>
        </>
      ),
      sortable: true,
      wrap: true,
      width:"220px"
    },
    {
      name: "Experience",
      selector: (row) => row?.experience,
      sortable: true,
      wrap: true,
      width:"120px"
    },
    {
      name: "Referral Code",
      selector: (row) => row?.referral_code,
      sortable: true,
      wrap: true,
    },
{
  name: "Referred By",
  selector: (row) => {
    const isNonEmptyObject = (obj) =>
  obj && Object.keys(obj).length > 0;

    const ref = row?.referredByDeatils;

   if (!isNonEmptyObject(row?.referredByDeatils)) return null;

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          padding: "6px 0",
        }}
      >
        <UserAvatarCell
          row={row}
          image={"/default-avatar.png"}
          name={ref?.name}
        />

        <div style={{ display: "flex", flexDirection: "column" }}>
          <span
            style={{
              fontWeight: 600,
              fontSize: "15px",
              color: "#111827",
              lineHeight: "1.2",
            }}
            className="text-capitalize"
          >
            {"Dr. "}
            {ref?.name}
          </span>

          <span
            style={{
              fontSize: "13px",
              color: "#6b7280",
            }}
          >
            {ref?.email}
          </span>
        </div>
      </div>
    );
  },
  sortable: true,
  wrap: true,
  width: "250px",
},

    {
      name: "KYC",
      selector: (row) => row?.KYC_status,
      cell: (row) => (
        <div
          style={{ cursor: "pointer" }}
          //  onClick={() => handleToggleStatus(row)}
        >
          <Badge
            className="text-capitalize"
            color={`${
              row.KYC_status == "pending"
                ? "outline-warning"
                : row?.KYC_status == "approved"
                ? "outline-success" : row?.KYC_status=="change_requested" ? "outline-danger"
                : "outline-teal"
            }`}
          >
            {row.KYC_status=="change_requested" ? "Change Requested":row?.KYC_status}
          </Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
      width:"120px"
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{ cursor: "pointer" }} onClick={() => handleToggleStatus(row)}>
          <Badge color={`${row.status ? "success" : "danger"}`}>{row.status ? "Active" : "InActive"}</Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
      width:"100px"
    },
    {
      name: "Action",
      wrap: true,
      width:"100px",
      cell: (row) => (
        <UncontrolledDropdown>
          <DropdownToggle tag="span" className="btn btn-icon btn-trigger" style={{ cursor: "pointer",   }}>
            <Icon name="more-h" />
          </DropdownToggle>
          <DropdownMenu style={{ minWidth: "50px", width: "100px", marginRight: "25px" }} end>
            {
              <div className="d-flex flex-column m-1 justify-content-center align-items-center h-100">
                <Button
                  outline
                  style={{ width: "50px" }}
                  color={`warning`}
                  size={`xs`}
                  id={`profile-${row?.id}`}
                  className={`me-1 my-1 d-flex flex-column m-1 justify-content-center align-items-center`}
                  onClick={() => viewDoctorProfile(row)}
                >
                  {" "}
                  <Icon name="eye" />
                </Button>
                <TooltipComponent
                  iconClass="card-hint"
                  direction="top"
                  id={`profile-${row?.id}`}
                  text="View Doctor Detail"
                />
                <Button
                  outline
                  style={{ width: "50px" }}
                  color={row?.is_feature ? `success` : `danger`}
                  size={`xs`}
                  id={`feature-${row?.id}`}
                  className={`me-1 d-flex flex-column m-1 justify-content-center align-items-center`}
                  onClick={() => handleFeatureDoctor(row)}
                >
                  {" "}
                  <Icon name="star" />
                </Button>
                <TooltipComponent
                  iconClass="card-hint"
                  direction="top"
                  id={`feature-${row?.id}`}
                  text={row?.is_feature ? "Remove doctor from feature list.":"Add doctor in feature list"}
                />
               {row?.KYCstatus=="approveda"?null:   <Button
                  outline
                  style={{ width: "50px" }}
                  color={`warning`}
                  size={`xs`}
                  className={`me-1 my-1 d-flex flex-column m-1 justify-content-center align-items-center`}
                  id={`edit-${row?.id}`}
                  onClick={() => handleEdit(row)}
                >
                  {" "}
                  <Icon name="edit" />
                </Button>}
                <TooltipComponent iconClass="card-hint" direction="top" id={`edit-${row?.id}`} text="Edit Doctor" />
               {row?.KYCstatus=="approved"?null: <Button
                  outline
                  style={{ width: "50px" }}
                  color={`warning`}
                  size={`xs`}
                  className={`me-1 my-1 d-flex flex-column m-1 justify-content-center align-items-center`}
                  id={`kyc-${row?.id}`}
                  onClick={() => handleKYC(row)}
                >
                  {" "}
                  <Icon name="setting" />
                </Button>}
                <TooltipComponent iconClass="card-hint" direction="top" id={`kyc-${row?.id}`} text="Doctor KYC" />
                <Button
                  outline
                  style={{ width: "50px" }}
                  color={`primary`}
                  size={`xs`}
                  className={`me-1 d-flex flex-column m-1 justify-content-center align-items-center `}
                  id={`slot-${row?.id}`}
                  onClick={() => handleSlotManagement(row)}
                >
                  {" "}
                  <Icon name="calendar-booking" />
                </Button>
                <TooltipComponent iconClass="card-hint" direction="top" id={`slot-${row?.id}`} text="Slot Management" />
              </div>
            }
            ,
          </DropdownMenu>
        </UncontrolledDropdown>
      ),
    },
  ]);
  const handleFeatureDoctor = (row) => {
    setValue("selectedRow",row)
    toggleFeature(); 
    
  };
  const handleImageOpenPreview = (row) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };
  const toggleFeature = () => {
    setFeatureModal(!featureModal);
  };
  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };
  const logout = useLogout();
  useEffect(() => {
    getDoctorList();
  }, []);
  const getDoctorList = () => {
    setValue("loading", true);
    getDoctorListAPI()
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        } else if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("data", res.data.data);
          setValue("loading", false);
        } else if (res.data.status === false) {
          setValue("loading", false);
          setValue("data", []);
          toast.error(!res.data.message);
          toast.clearWaitingQueue();
        }
      })
      .catch((err) => {
        setValue("loading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const viewDoctorProfile = (row)=>{
    navigate("/doctor/detail", {state:{ doctor_id: row?.id }})
  }
  const handleKYC = (row) => {
    navigate("/doctor/registration", { state: { data: row, mode: "Approval" } });
  };
  const handleEdit = (row) => {
    navigate("/doctor/registration", { state: { data: row, mode: "Edit" } });
  };
  const handleSlotManagement = (row) => {
    navigate("/doctor/slot-management", { state: { data: row } });
  };
  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };
  const confirmStatusChange = (data) => {
    const updatedStatus = watch("selectedRow").status === true ? false : true;

    const formObject = {
      id: watch("selectedRow").id,
      status: updatedStatus,
    };
    updateDoctorAPI(formObject)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          getDoctorList();
          setValue("isLoading", false);
          setShowModal(false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const confirmFeature =(data)=>{
    console.log("Data",data)
      const updatedStatus = watch("selectedRow").is_feature === true ? false : true;

    const formObject = {
      id: watch("selectedRow").id,
      is_feature: updatedStatus,
    };
    updateDoctorAPI(formObject)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          getDoctorList();
          setValue("isLoading", false);
          toggleFeature();
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  }
  return (
    <>
      <Head title={"Doctor List | Doctor"} />
      <Content>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage Doctors"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    navigate("/doctor/registration", { state: { mode: "Add" } });
                  }}
                >
                  <Icon name={"user-add"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <MyDataTable data={data || []} columns={column} isLoading={loading} title={"Doctor List"} />
        </Block>
      </Content>

      <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />

      <ConfirmModal
        isOpen={showModal}
        toggle={() => setShowModal(!showModal)}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
      />

      <FeatureModal
      isOpen={featureModal}
      toggle={toggleFeature}
      onConfirm={confirmFeature}
      data={watch("selectedRow")}
      status={watch("selectedRow")?.status}
      />
    </>
  );
};

export default DoctorList;
